import z from "zod"

export enum errorCodesEnum {
  noSpecialCharacters = "noSpecialCharacters",
  ValueTooLong = "ValueTooLong",
  ValueTooShort = "ValueTooShort",
  invalidEmail = "invalidEmail",
  errorDefault = "errorDefault",
}

export type errorCodes = typeof errorCodesEnum
export const errorMap: z.ZodErrorMap = (issue) => {
  const message = issue.message ?? "An error occurred"
  if (issue.code === "too_small") {
    return {
      message: `ValueTooShort`,
    }
  }
  if (issue.code === "too_big") {
    return {
      message: `ValueTooLong`,
    }
  }
  return { message }
}

// ! KEEP THESE COMMMENTS TO PREVENT I18N KEY REMOVAL
// t("zodErrors.noSpecialCharacters")
// t("zodErrors.ValueTooLong")
// t("zodErrors.ValueTooShort")
// t("zodErrors.invalidEmail")
// t("zodErrors.errorDefault")

export const StringNoSpecialCharactersSchema = z
  .string({ error: errorMap })
  .max(100)
  .min(1)
  .refine(
    (value) => {
      const nameRegex = /^[\p{L}'\- ]+$/u // Matches Unicode letters, spaces, apostrophes, and hyphens
      return nameRegex.test(value.trim())
    },
    {
      error: "noSpecialCharacters",
    }
  )
